import { VALIDATIONS_CASES } from './validations.constant';

export interface IError {
    msg: string;
    value: boolean;
}

export interface ValidationRule {
    case: keyof typeof VALIDATIONS_CASES;
    message?: string;
}

function useValidation() {
    const validateField = (value: any, validations: (ValidationRule | keyof typeof VALIDATIONS_CASES)[]): IError | null => {
        for (const validation of validations) {
            const rule = typeof validation === 'string' ? { case: validation } : validation;
            const errorCase = VALIDATIONS_CASES[rule.case];
            if (!errorCase) continue;

            const isValid = errorCase.validator(value);
            if (!isValid) {
                return {
                    msg: rule.message || errorCase.message,
                    value: true,
                };
            }
        }
        return null;
    };

    return { validateField };
}

export default useValidation;
